/**
 * Mobilde (lg altı) ardışık KPI'lar ikişer yan yana; tek sayılı dizinin sonuncusu tam satır.
 * Tek sütunda her KPI ayrı satır olunca dört KPI veriyi ilk ekranın altına itiyordu.
 */
export function pairedKpi(items: readonly { type: string }[], index: number) {
  if (items[index]?.type !== 'kpi') return false
  let start = index
  while (start > 0 && items[start - 1].type === 'kpi') start -= 1
  let end = index
  while (end + 1 < items.length && items[end + 1].type === 'kpi') end += 1
  const length = end - start + 1
  return length > 1 && !(length % 2 === 1 && index === end)
}
